import React from 'react';
import PublicHeader from '../PublicHeader';
import PublicFooter from '../PublicFooter';

const phone = process.env.PUBLIC_URL + '/img/phone-login.png';

const content = {
    bs: {
        nav: {
            home: 'Početna',
            mobile: 'Mobilna aplikacija',
            privacy: 'Privatnost',
            login: 'Prijava'
        },
        badge: 'Mobilna aplikacija · eUNSA',
        studentNote: 'Aplikacija je namijenjena isključivo studentima Univerziteta u Sarajevu. Nastavno osoblje i službe Univerziteta sistemu pristupaju putem web aplikacije.',
        h1a: 'Tvoj studij u',
        h1b: 'jednoj aplikaciji',
        sub: 'Jedinstveni informacioni sistem Univerziteta u Sarajevu',
        desc: 'Studij, ocjene, ispiti, ankete, dokumenti i obavijesti — sve na jednom mjestu, dostupno bilo kad i bilo gdje, direktno s tvog telefona.',
        androidSmall: 'Preuzmi na',
        iosSmall: 'Uskoro na',
        powered: 'Powered by',
        secTitle: 'Sve što ti treba na studiju',
        secSub: 'Brz pristup najvažnijim informacijama tvog studija',
        features: [
            { t: 'Studij i ocjene', d: 'Podaci o semestru, predmetima i ocjenama tvog studija.' },
            { t: 'Ispiti', d: 'Termini ispita i prijave — sve na jednom mjestu.' },
            { t: 'Ankete', d: 'Studentske ankete i evaluacija nastave.' },
            { t: 'Dokumenti', d: 'Potvrde i dokumenti tvog studija — brzo i jednostavno.' },
            { t: 'Lični podaci', d: 'Tvoji lični podaci i informacije o profilu studenta.' },
            { t: 'Fakultet i osoblje', d: 'Informacije o fakultetu, nastavnom osoblju i kontaktima.' }
        ],
        webBack: '← Nazad na eUNSA web sistem'
    },
    en: {
        nav: {
            home: 'Home',
            mobile: 'Mobile app',
            privacy: 'Privacy',
            login: 'Sign in'
        },
        badge: 'Mobile app · eUNSA',
        studentNote: 'The application is intended exclusively for students of the University of Sarajevo. Teaching staff and University services access the system through the web application.',
        h1a: 'Your studies in',
        h1b: 'one application',
        sub: 'Unified Information System of the University of Sarajevo',
        desc: 'Studies, grades, exams, surveys, documents and notifications — all in one place, available anytime and anywhere, directly from your phone.',
        androidSmall: 'Get it on',
        iosSmall: 'Soon on',
        powered: 'Powered by',
        secTitle: 'Everything you need for your studies',
        secSub: 'Quick access to the most important information about your studies',
        features: [
            { t: 'Studies & grades', d: 'Information about your semester, courses and grades.' },
            { t: 'Exams', d: 'Exam dates and registrations — all in one place.' },
            { t: 'Surveys', d: 'Student surveys and teaching evaluations.' },
            { t: 'Documents', d: 'Certificates and documents of your studies — quick and simple.' },
            { t: 'Personal data', d: 'Your personal data and student profile information.' },
            { t: 'Faculty & staff', d: 'Information about the faculty, teaching staff and contacts.' }
        ],
        webBack: '← Back to the eUNSA web system'
    }
};

function getInitialLang() {
    try { return localStorage.getItem('publicLang') || 'bs'; } catch (e) { return 'bs'; }
}

export default function MobileLanding() {
    const [lang, setLang] = React.useState(getInitialLang);
    const c = content[lang];

    function changeLang(l) {
        try { localStorage.setItem('publicLang', l); } catch (e) { /* ignore */ }
        setLang(l);
    }

    const navLinks = [
        { href: '/public/landing', label: c.nav.home },
        { href: '/public/mobile', label: c.nav.mobile },
        { href: '/public/privacy-policy', label: c.nav.privacy }
    ];

    return (
        <React.Fragment>
            <style>{`
                .landing-page {
                    --bg: #080c14;
                    --bg-2: #0d141f;
                    --navy: #141d2b;
                    --blue: #1d6ea4;
                    --blue-light: #5aa1d8;
                    --blue-accent: #3b87c4;
                    --text: #eaf1f8;
                    --muted: #8a97a9;
                    --card: rgba(255, 255, 255, 0.04);
                    --border: rgba(255, 255, 255, 0.08);
                    --radius: 18px;
                    font-family: 'Inter', system-ui, sans-serif;
                    color: var(--text);
                    background: var(--bg);
                    line-height: 1.6;
                    overflow-x: hidden;
                    min-height: 100vh;
                    position: relative;
                    scroll-behavior: smooth;
                    -webkit-font-smoothing: auto;
                    -moz-osx-font-smoothing: auto;
                }
                .landing-page * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Inter', system-ui, sans-serif; }
                /* pozadina: tackice + plavi radijalni sjaj */
                .landing-page::before {
                    content: "";
                    position: fixed; inset: 0; z-index: 0;
                    background:
                        radial-gradient(circle at 50% 35%, rgba(29, 110, 164, 0.28), transparent 55%),
                        radial-gradient(circle at 85% 80%, rgba(29, 110, 164, 0.18), transparent 50%),
                        var(--bg);
                }
                .landing-page::after {
                    content: "";
                    position: fixed; inset: 0; z-index: 0;
                    background-image: radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px);
                    background-size: 26px 26px;
                    mask-image: radial-gradient(circle at 50% 40%, #000 30%, transparent 85%);
                    -webkit-mask-image: radial-gradient(circle at 50% 40%, #000 30%, transparent 85%);
                }
                .landing-page header,
                .landing-page main,
                .landing-page footer { position: relative; z-index: 1; }
                .landing-page .wrap { max-width: 1160px; margin: 0 auto; padding: 0 24px; }

                /* HERO */
                .landing-page .hero { display: grid; grid-template-columns: 1.05fr 0.95fr; gap: 50px; align-items: center; padding: 80px 0 70px; }
                .landing-page .badge {
                    display: inline-flex; align-items: center; gap: 8px;
                    background: var(--card); border: 1px solid var(--border);
                    padding: 7px 14px; border-radius: 100px; font-size: 13px; color: var(--blue-light);
                    font-weight: 600; margin-bottom: 24px;
                }
                .landing-page .badge .dot { width: 7px; height: 7px; border-radius: 50%; background: var(--blue-light); box-shadow: 0 0 10px var(--blue-light); }
                .landing-page h1 { font-size: clamp(38px, 6vw, 62px); line-height: 1.05; font-weight: 900; letter-spacing: -1.5px; }
                .landing-page h1 .grad { background: linear-gradient(120deg, var(--blue-light), #9cc8ec); -webkit-background-clip: text; background-clip: text; color: transparent; }
                .landing-page .sub { color: var(--muted); font-size: 19px; margin: 22px 0 14px; font-weight: 500; }
                .landing-page .desc { color: var(--muted); font-size: 16px; max-width: 520px; margin-bottom: 22px; }
                .landing-page .student-note {
                    color: var(--muted); font-size: 14px; max-width: 520px; margin-bottom: 32px;
                    border-left: 2px solid rgba(90,161,216,.5); padding-left: 14px; text-align: left;
                }

                .landing-page .stores { display: flex; gap: 14px; flex-wrap: wrap; }
                .landing-page .store-btn {
                    display: inline-flex; align-items: center; gap: 12px;
                    background: #fff; color: #0a0e16; text-decoration: none;
                    padding: 12px 22px; border-radius: 14px; transition: transform .15s, box-shadow .2s;
                    box-shadow: 0 8px 30px rgba(0,0,0,.35);
                }
                .landing-page .store-btn:hover { transform: translateY(-3px); box-shadow: 0 14px 40px rgba(90,161,216,.25); }
                .landing-page .store-btn svg { width: 28px; height: 28px; flex-shrink: 0; }
                .landing-page .store-btn .st-text { display: flex; flex-direction: column; gap: 4px; }
                .landing-page .store-btn .st-small { font-size: 11px; line-height: 1; opacity: .7; text-transform: uppercase; letter-spacing: .5px; }
                .landing-page .store-btn .st-big { font-size: 18px; font-weight: 700; line-height: 1; }
                .landing-page .store-btn.soon { background: var(--card); color: var(--text); border: 1px solid var(--border); box-shadow: none; }
                .landing-page .store-btn.soon .st-small { color: var(--blue-light); opacity: 1; }

                .landing-page .powered { margin-top: 26px; font-size: 13px; color: var(--muted); letter-spacing: 1px; }
                .landing-page .powered b { color: var(--blue-light); font-weight: 600; }

                /* PHONE */
                .landing-page .phone-stage { display: flex; justify-content: center; position: relative; }
                .landing-page .phone-stage::before {
                    content: ""; position: absolute; width: 360px; height: 360px;
                    background: radial-gradient(circle, rgba(29,110,164,.45), transparent 70%);
                    filter: blur(30px); z-index: 0;
                }
                .landing-page .phone {
                    position: relative; z-index: 1;
                    width: 290px; aspect-ratio: 9 / 19.3;
                    background: var(--navy);
                    border: 11px solid #1b2535;
                    border-radius: 42px;
                    box-shadow: 0 30px 70px rgba(0,0,0,.55), inset 0 0 0 1px rgba(255,255,255,.04);
                    overflow: hidden;
                    animation: landing-float 5s ease-in-out infinite;
                }
                .landing-page .phone::before {
                    content: ""; position: absolute; top: 14px; left: 50%; transform: translateX(-50%);
                    width: 110px; height: 7px; background: #0a0f17; border-radius: 10px; z-index: 3;
                }
                .landing-page .phone img { width: 100%; height: 100%; object-fit: cover; display: block; }
                @keyframes landing-float { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-16px); } }

                @media (max-width: 860px) {
                    .landing-page .hero { grid-template-columns: 1fr; text-align: center; gap: 60px; padding: 50px 0; }
                    .landing-page .desc { margin-left: auto; margin-right: auto; }
                    .landing-page .student-note { margin-left: auto; margin-right: auto; }
                    .landing-page .stores { justify-content: center; }
                    .landing-page .badge { margin-inline: auto; }
                }

                /* FEATURES */
                .landing-page .features { padding: 70px 0 40px; }
                .landing-page .sec-title { text-align: center; font-size: 32px; font-weight: 800; letter-spacing: -.5px; margin-bottom: 10px; }
                .landing-page .sec-sub { text-align: center; color: var(--muted); margin-bottom: 50px; }
                .landing-page .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; }
                @media (max-width: 860px) { .landing-page .grid { grid-template-columns: 1fr; } }
                .landing-page .card {
                    background: var(--card); border: 1px solid var(--border); border-radius: var(--radius);
                    padding: 26px; transition: transform .2s, border-color .2s, background .2s;
                }
                .landing-page .card:hover { transform: translateY(-4px); border-color: rgba(90,161,216,.4); background: rgba(29,110,164,.08); }
                .landing-page .ic {
                    width: 48px; height: 48px; border-radius: 12px; display: grid; place-items: center;
                    background: rgba(29,110,164,.18); color: var(--blue-light); margin-bottom: 16px;
                }
                .landing-page .ic svg { width: 24px; height: 24px; }
                .landing-page .card h3 { font-size: 18px; font-weight: 700; margin-bottom: 6px; }
                .landing-page .card p { color: var(--muted); font-size: 15px; }

                .landing-page .web-back { display: block; text-align: center; margin-top: 44px; color: var(--blue-light); text-decoration: none; font-size: 15px; font-weight: 600; }
                .landing-page .web-back:hover { text-decoration: underline; }

                .landing-page footer { position: relative; z-index: 1; }
            `}</style>

            <div className="landing-page">
                <PublicHeader
                    lang={lang}
                    onLangChange={changeLang}
                    links={navLinks}
                    loginLabel={c.nav.login}
                />

                <main className="wrap">

                    {/* HERO */}
                    <section className="hero" id="pocetna">
                        <div>
                            <span className="badge"><span className="dot" /> {c.badge}</span>
                            <h1>{c.h1a}<br /><span className="grad">{c.h1b}</span></h1>
                            <p className="sub">{c.sub}</p>
                            <p className="desc">{c.desc}</p>

                            <p className="student-note">{c.studentNote}</p>

                            <div className="stores" id="preuzmi">
                                <a className="store-btn" href="#" aria-label="Google Play">
                                    <svg viewBox="0 0 512 512" fill="none">
                                        <path d="M325 234 110 19a30 30 0 0 0-15-8l230 230 0 0ZM48 12a30 30 0 0 0-13 25v438a30 30 0 0 0 13 25l239-239L48 12Zm377 213-67-39-73 73 73 73 68-39c22-13 22-55-1-68ZM95 501a30 30 0 0 0 15-8l215-215-58-58L95 501Z" fill="#36B14C" />
                                    </svg>
                                    <span className="st-text"><span className="st-small">{c.androidSmall}</span><span className="st-big">Google Play</span></span>
                                </a>
                                <a className="store-btn soon" href="#" aria-label="App Store">
                                    <svg viewBox="0 0 384 512" fill="currentColor">
                                        <path d="M318 268c-1-37 17-65 53-86-20-29-50-45-90-48-38-3-79 22-94 22-15 0-52-21-81-21-60 1-124 47-124 143 0 28 5 57 16 87 14 39 64 135 116 133 27-1 46-19 81-19 34 0 52 19 81 19 53-1 98-88 111-127-70-33-66-97-66-99zM256 84c30-36 27-69 26-81-26 2-57 18-74 38-19 22-30 49-27 79 28 2 54-12 75-36z" />
                                    </svg>
                                    <span className="st-text"><span className="st-small">{c.iosSmall}</span><span className="st-big">App Store</span></span>
                                </a>
                            </div>

                            <p className="powered">{c.powered} <b>UTIC</b> · Univerzitet u Sarajevu</p>
                        </div>

                        <div className="phone-stage">
                            <div className="phone">
                                <img src={phone} alt="eUNSA — login" />
                            </div>
                        </div>
                    </section>

                    {/* FEATURES */}
                    <section className="features" id="mogucnosti">
                        <h2 className="sec-title">{c.secTitle}</h2>
                        <p className="sec-sub">{c.secSub}</p>
                        <div className="grid">
                            <div className="card">
                                <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2 3 7l9 5 9-5-9-5Z" /><path d="M3 7v6l9 5 9-5V7" /></svg></div>
                                <h3>{c.features[0].t}</h3>
                                <p>{c.features[0].d}</p>
                            </div>
                            <div className="card">
                                <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" /><path d="M14 2v6h6M9 15l2 2 4-4" /></svg></div>
                                <h3>{c.features[1].t}</h3>
                                <p>{c.features[1].d}</p>
                            </div>
                            <div className="card">
                                <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></svg></div>
                                <h3>{c.features[2].t}</h3>
                                <p>{c.features[2].d}</p>
                            </div>
                            <div className="card">
                                <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h6l2 2h8v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Z" /></svg></div>
                                <h3>{c.features[3].t}</h3>
                                <p>{c.features[3].d}</p>
                            </div>
                            <div className="card">
                                <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg></div>
                                <h3>{c.features[4].t}</h3>
                                <p>{c.features[4].d}</p>
                            </div>
                            <div className="card">
                                <div className="ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg></div>
                                <h3>{c.features[5].t}</h3>
                                <p>{c.features[5].d}</p>
                            </div>
                        </div>

                        <a className="web-back" href="/public/landing">{c.webBack}</a>
                    </section>

                </main>

                <PublicFooter lang={lang} />
            </div>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/views/Public/MobileLanding/MobileLanding.js